<div class="modal fade saveAlertModal" tabindex="-1" role="dialog" id="saveAlertModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" >
                    <div class="modal-header">
                            <h3 class="modal-title" id="modalLabel">{{ 'SHARED.SAVEALERT.ARE_YOU_SURE' | translate }}</h3>
                    </div>
                    <div class="modal-body">
                            <p class="mb-2"> {{ 'SHARED.SAVEALERT.LOOSE_WORK_WARNING_MESSAGE' | translate }}</p>
                    </div>
                    <div class="modal-footer">
                            <button class="btn" (click)="saveAlertActionSelection(false)" data-dismiss="modal" qid="ralert-1">{{ 'SHARED.SAVEALERT.SAVE' | translate }}</button>
                            <button class="btn" (click)="saveAlertActionSelection(true)" data-dismiss="modal" qid="ralert-2">
                                {{ 'SHARED.SAVEALERT.EXIT' | translate }}
                            </button>
                    </div>
            </div>
    </div>
</div>